var _ellipse, _rect, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackFiliais(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 467,
    viewBox: "0 0 626 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: -11,
    cy: 234,
    rx: 75,
    ry: 144,
    fill: "#244B38"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    width: 161,
    height: 467,
    fill: "#244B38"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249,
    cy: 233.5,
    rx: 138,
    ry: 245.5,
    fill: "#244B38"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 662,
    cy: 234,
    rx: 75,
    ry: 144,
    fill: "#244B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackFiliais);
export default __webpack_public_path__ + "static/media/back_filiais.ae53a1ce4240f8067e95d77b540265b5.svg";
export { ForwardRef as ReactComponent };